import PropTypes from 'prop-types'
import { Badge, Table } from 'reactstrap'
import TimeUtil from 'utils/time-util'

const propTypes = {
  sellerProduct  : PropTypes.object,
  isProductAging : PropTypes.bool
}

const defaultProps = {
  sellerProduct  : {},
  isProductAging : false
}

/**
 * Multi-purpose Scraper Product view.
 * It display about the Scraper Product information
 * @param {object} sellerProduct - seller product that will be displayed in view
 * @param {boolean} isProductAging - boolean to display aging badge
 */
const SellerProductView = ({
  sellerProduct,
  isProductAging
}) => (
  <>
    <div className='d-flex justify-content-between align-items-center mb-2'>
      <h2>
            Seller Product: { sellerProduct.original_sku || '' }
      </h2>
      <h2>
        { isProductAging && <Badge color="warning" pill>{ 'aging' }</Badge> }
      </h2>
    </div>

    <Table
      bordered
      hover
      className='mb-0'
      size='sm'
      responsive
    >
      <tbody>
        <tr>
          <th scope='row'>ID</th>
          <td>{ sellerProduct.id || 'not set' }</td>
        </tr>
        <tr>
          <th scope='row'>Auto Discount</th>
          <td>{ `${sellerProduct.auto_discount}` }</td>
        </tr>
        <tr>
          <th scope='row'>SKU</th>
          <td>{ sellerProduct.sku || 'not set' }</td>
        </tr>
        <tr>
          <th scope='row'>Name</th>
          <td>{ sellerProduct.name || 'not set' }</td>
        </tr>
        <tr>
          <th scope='row'>Live Process Status</th>
          <td>{ sellerProduct.live_process_status || 'not set' }</td>
        </tr>
        <tr>
          <th scope='row'>Return Date</th>
          <td>{ TimeUtil.format(sellerProduct.return_date, 'DD MMM YYYY') || 'not set' }</td>
        </tr>
      </tbody>
    </Table>
  </>
)

SellerProductView.propTypes    = propTypes
SellerProductView.defaultProps = defaultProps

export default SellerProductView